import Vue from "vue";
import money from 'v-money';
//const money = require('v-money');

Vue.use(money, {precision: 4});